(function () {
    'use strict';

    angular
        .module('franchisee.constants')
        .constant('PATHS_FRANCHISEE', {
            PHYSICAL: '/app/src/angular/franchisee'
        });
}());